var _path, _path2, _path3, _rect, _polygon, _polygon2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect2, _polygon3, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "planning",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8890",
    d: "M11.5,3a.5.5,0,0,1-.5-.5A1.5,1.5,0,0,0,9.5,1h-1A1.5,1.5,0,0,0,7,2.5a.5.5,0,0,1-1,0A2.5,2.5,0,0,1,8.5,0h1A2.5,2.5,0,0,1,12,2.5.5.5,0,0,1,11.5,3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#416fb3",
    d: "M25.5,31.5H23.4a1,1,0,0,1-1-.9l-.91-9.1h7v9a1,1,0,0,1-1,1h-2v0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d8da",
    d: "M17.5,15.5v1a2,2,0,0,1-2,2H2.5a2,2,0,0,1-2-2V4.5a2,2,0,0,1,2-2h13a2,2,0,0,1,2,2v11Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 11,
    x: 8,
    y: 20.5,
    fill: "#57565c"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#57565c",
    points: "3 31.5 1 31.5 4 20.5 6 20.5 3 31.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#57565c",
    points: "15 31.5 17 31.5 14 20.5 12 20.5 15 31.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8890",
    d: "M2.5,18.5h13a0,0,0,0,1,0,0v0a2,2,0,0,1-2,2h-9a2,2,0,0,1-2-2v0A0,0,0,0,1,2.5,18.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed456a",
    d: "M31.5,15.5v6a2.006,2.006,0,0,1-2,2h-1v-2h-7v-7l-3.54.88a.943.943,0,0,1-.84-.17L15.5,14l-.8-.6A3,3,0,0,1,13.5,11V9.5l4,3,4-1h6A4,4,0,0,1,31.5,15.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565c",
    d: "M4.5 16h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1zM4.5 12h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1zM4.5 14h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565c",
    d: "M4.5 14a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v2A.5.5 0 0 1 4.5 14zM2.5 16a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v2A.5.5 0 0 1 2.5 16z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc37a",
    d: "M27,10v2a1.5,1.5,0,0,1-1.5,1.5h0A1.5,1.5,0,0,1,24,12V10Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565c",
    d: "M4.5,10h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565c",
    d: "M3.5 10A.5.5 0 0 1 3 9.5V6.707l-.146.146a.5.5 0 0 1-.707-.707l1-1A.5.5 0 0 1 4 5.5v4A.5.5 0 0 1 3.5 10zM7.5 6h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM8.5 8h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1zM11.5 14h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1zM11.5 12h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1zM14.5 13a.5.5 0 0 1-.435-.252l-5-8a.5.5 0 0 1 .869-.5l5 8a.5.5 0 0 1-.187.682A.494.494 0 0 1 14.5 13z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd9aa",
    d: "M31.5 20.5v1a2.006 2.006 0 0 1-2 2h-1v-3zM15.5 11v3l-.8-.6A3 3 0 0 1 13.5 11V9.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#e13442",
    d: "M28.5 17.5V21h-1V17.5a.5.5 0 0 1 1 0zM22.5 17.5V21h-1V17.5a.5.5 0 0 1 1 0z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#23579f",
    d: "M26,24.5v7H25v-7a.5.5,0,0,1,1,0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#e13442",
    d: "M15.98,14.36a1.1,1.1,0,0,0,.02-.18v-2.8L15.5,11l-.49-.37a.487.487,0,0,0-.01.12v2.88Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    x: 28.5,
    y: 20,
    fill: "#e13442"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e13442",
    points: "28.5 21 21.5 21 21.5 21.5 21.56 22 28.5 22 28.5 21"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd9aa",
    d: "M29,7.5a.756.756,0,0,1-.01.15,3.494,3.494,0,0,1-6.98.05A1.339,1.339,0,0,1,22,7.5a3.5,3.5,0,0,1,7,0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#57565d",
    d: "M29,7.5a.756.756,0,0,1-.01.15L28.5,7.5l-2.86-.81a2,2,0,0,0-1.3.07L22.5,7.5l-.49.2A1.339,1.339,0,0,1,22,7.5a3.5,3.5,0,0,1,7,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.64ab8f49485ee4de7c6ae2f65578127f.svg";
export { ForwardRef as ReactComponent };